import { useFormikContext } from "formik";
import { useWorkflowVersions } from "../../data/workflow";
import FormikDropdown from "./FormikDropdown";
import { useState, useEffect } from "react";

export default function FormikVersionDropdown(props) {
  const { name, workflowName } = props;
  
  const { data: namesAndVersions, refetch } = useWorkflowVersions(workflowName);
  
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    if (namesAndVersions) {
      const sortedVersions = namesAndVersions.sort((a, b) => a - b);
      setVersions(sortedVersions);
    }
  }, [namesAndVersions]);

  useEffect(() => {
    // Trigger a refetch when workflowName changes
    refetch();
  }, [workflowName]);

  return <FormikDropdown options={versions?versions.map(String):[]} {...props} />;
}
